@if (hasVirtualFence()) {
  @if (virtualFenceService.isEmptyVirtualFence() && readonly() && !isAdmin()) {
    <div>Virtual fence construction rules are cleared!</div>
  } @else if (notAvailableForIds()?.length) {
    <mat-error>
      Virtual fence construction rules are not available for collar IDs:
      {{ notAvailableForIds()?.join(', ') }}.
    </mat-error>
  } @else if (
    !virtualFenceService.isEmptyVirtualFence() &&
    !virtualFenceService.allPolygons()?.length &&
    readonly()
  ) {
    <div>There is no virtual fence construction rule!</div>
  } @else if (!hideConstructionRules()) {
    <div [ngClass]="isFullScreen() ? 'map-wrapper-xl' : 'map-wrapper'" class="h-100">
      <sm-shared-map-page
        [isVirtualFenceEnabled]="true"
        [hideSettingsBtn]="true"
        [hasMinHeight]="true"
        [virtualFenceIds]="selectedCollarIds()"
        [mapPositions]="mapPositions()"
        [isViewOnlyMode]="readonly()"
        [isLoading]="isPositionsLoading()"
        [userPreferences]="userPreferences()"
        [initialLastXRecordsValue]="lastXRecords() ?? 50"
        (loadPositionsEvent)="loadPositions.emit($event)"
        (setEmptyVirtualFence)="virtualFenceService.onSetEmptyVirtualFence()"
        (cancelNewPolygonCreation)="virtualFenceService.cancelNewPolygonCreation()"
        (virtualFenceFileSelected)="virtualFenceService.onVirtualFenceFileSelected($event)"
        [allPolygons]="virtualFenceService.allPolygons()"
        [currentlyEditingFenceId]="virtualFenceService.currentlyEditingFenceId"
        (startEditingPolygon)="virtualFenceService.startEditingPolygon($event)"
        [isEditModeVirtualFence]="virtualFenceService.isEditMode()"
        (setFocusOnPolygon)="virtualFenceService.setFocusOnPolygon($event)"
        [readonlyVirtualFence]="virtualFenceService.readonly()"
        [drawHandlerVirtualFence]="virtualFenceService.drawHandler()"
        (createNewPolygon)="virtualFenceService.createNewPolygon()"
        [isEmptyVirtualFence]="virtualFenceService.isEmptyVirtualFence()"
        [hasEmptyVirtualFence]="virtualFenceService.hasEmptyVirtualFence()"
        (virtualFencePointChanged)="virtualFenceService.virtualFencePointChanged($event)"
        (saveEditedPolygon)="virtualFenceService.saveEditedPolygon($event)"
        (deletePolygon)="virtualFenceService.deletePolygon($event)"
        [isVirtualFenceFilled]="virtualFenceService.isVirtualFenceFilled()"
        (resetVirtualFence)="virtualFenceService.resetToDefaultVirtualFence()"
        [showOverrideWarning]="showOverrideWarning()"
      ></sm-shared-map-page>
    </div>
  }
  <mat-divider></mat-divider>
}
